import loggingService from '../services/util/loggingService'

var serviceName = 'organizationService'
var path = '/Organization/'
var isDebug = false

function listLookup (http) {
    loggingService.log(isDebug, serviceName, 'listLookup')

    return http.get(path + 'ListLookup')
}

function listLeadAgencyLookup (http) {
    loggingService.log(isDebug, serviceName, 'listLeadAgencyLookup')

    return http.get(path + 'ListLeadAgencyLookup')
}

function listBlmLookup (http) {
    loggingService.log(isDebug, serviceName, 'listBlmLookup')

    return http.get(path + 'ListBlmLookup')
}

function listShapeFileRestrictedOrgs (http) {
    loggingService.log(isDebug, serviceName, 'listShapeFileRestrictedOrgs')

    return http.get(path + 'ListShapeFileRestrictedOrgs')
}

function list (http) {
    loggingService.log(isDebug, serviceName, 'List')
    return http.get(path + 'List')
}

function put (http, organizationDto) {
    loggingService.log(isDebug, serviceName, 'Put')
    return http.put(path, organizationDto)
}

function getBillingCodeList () {
    return [
        {billingCodeId: 1, amount: 30.00, description: 'Standard'},
        {billingCodeId: 2, amount: 0.00, description: 'No Fee'}
    ]
}

export default {
    listLookup: listLookup,
    listLeadAgencyLookup: listLeadAgencyLookup,
    listBlmLookup: listBlmLookup,
    listShapeFileRestrictedOrgs: listShapeFileRestrictedOrgs,
    list: list,
    put: put,
    getBillingCodeList: getBillingCodeList
}



// WEBPACK FOOTER //
// ./src/services/organizationService.js